import { Gallery } from "react-photoswipe-gallery";
import { useState } from "react";
import ReactPlayer from "react-player";
import ThreadGalleryItem from "./ThreadGalleryItem";
import Modal from "../Modal/Modal";

interface IThreadGallery {
  documents?: any;
  isPrivate?: boolean;
  onRemoveFile?: any;
  editMode?: boolean;
  small?: boolean;
  exifData?: any[];
}
function ThreadGallery({
  documents,
  isPrivate,
  onRemoveFile,
  editMode,
  small = false,
  exifData,
}: IThreadGallery) {
  const containerStyle = isPrivate ? "flex gap-1" : "flex gap-1 justify-end";
  const [videoURL, setVideoURL] = useState<string | null>(null);
  const list = (documents || []).map((file: any) => (
    <ThreadGalleryItem
      key={file.uri}
      file={file}
      onRemoveFile={() => onRemoveFile(file)}
      onVideoClick={(url: string) => {
        setVideoURL(url);
      }}
      editMode={editMode}
      small={small}
      exifData={exifData}
    />
  ));

  if (!documents || documents.length < 1) {
    return null;
  }
  return (
    <div>
      <Modal visible={Boolean(videoURL)} onCloseModal={() => setVideoURL(null)}>
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            background: "#000",
          }}
        >
          <ReactPlayer
            config={{ file: { forceVideo: true } }}
            url={videoURL ?? undefined}
            controls
            playing
            stopOnUnmount
            style={{ height: "100%", width: "100%" }}
          />
        </div>
      </Modal>
      <Gallery withDownloadButton withCaption>
        <div className={containerStyle}>{list}</div>
      </Gallery>
    </div>
  );
}

export default ThreadGallery;
